import { render, staticRenderFns } from "./Badges_Subcategory.vue?vue&type=template&id=61d3a586&scoped=true&"
import script from "./Badges_Subcategory.vue?vue&type=script&lang=js&"
export * from "./Badges_Subcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d3a586",
  null
  
)

export default component.exports